module.exports = __webpack_public_path__ + "img/list_10_tc.90291337.png";